import { render } from "./LikeBtn.vue?vue&type=template&id=49d3580b"
import script from "./LikeBtn.vue?vue&type=script&lang=js"
export * from "./LikeBtn.vue?vue&type=script&lang=js"

import exportComponent from "/media/ehsan/projects/Projects/iranget-v9/vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__